import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"];

/* eslint-disable react/prop-types */
import React from 'react';
import { DynamicWidgets as CoreDynamicWidgets } from 'react-instantsearch-core';
import classNames from 'classnames';
import { createClassNames } from '../core/utils';
var cx = createClassNames('DynamicWidgets');
export default function DynamicWidgets(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(cx(''), className)
  }, /*#__PURE__*/React.createElement(CoreDynamicWidgets, props, children));
}